<template>
  <div class="flex-row flex__left">
    <el-popover trigger="hover" placement="top" width="500">
      <el-table
        :data="coordinators"
        style="width: 100%"
        size="medium"
        :show-header="false"
        max-height="300"
        stripe
      >
        <el-table-column type="index"></el-table-column>

        <el-table-column show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ customLabelSelectPeople(scope.row) }}</span>
          </template>
        </el-table-column>

        <el-table-column width="60" align="left" v-if="isAbleToUpdate">
          <template slot-scope="scope">
            <i
              class="el-icon-circle-close margin-left-10 margin-right-10 font-size__large color__red clickable"
              @click="removeCoordinator(scope.row)"
            ></i>
          </template>
        </el-table-column>
      </el-table>

      <div slot="reference" class="list-people margin-right-10">
        <div
          v-for="coordinator in (coordinators || []).slice(0, 3)"
          :key="coordinator.id"
          class="item"
        >
          <div v-if="coordinator.url" class="avatar_bg"></div>
          <div v-else class="avatar_fake flex-row flex__center">
            {{ coordinator.fullName | buildShortNameFilter }}
          </div>
        </div>
        <div
          v-show="coordinators && coordinators.length > 3"
          class="item avatar_fake flex-row flex__center"
        >
          +{{ coordinators.length - 3 }}
        </div>
      </div>
    </el-popover>

    <el-button
      size="medium"
      class="addDocs flex-row flex__center btn-none__border color__black"
      @click="isOpenAddCoordinatorsDialog = true"
      v-if="isAbleToUpdate"
    >
      <span class="flex-row flex__center">
        <i class="fas fa-user-plus font-size__small color__cyan"></i>
        &nbsp;Thêm
      </span>
    </el-button>

    <dialog-add-people
      :isOpen="isOpenAddCoordinatorsDialog"
      :addedPeopleIds="coordinatorIds"
      :delegatorId="delegatorId"
      :taskId="tkTaskId"
      :receiverUserDeptRole="receiverUserDeptRole"
      v-if="isEnableAddCoordinatorsDialog"
      @closed="isEnableAddCoordinatorsDialog = false"
      @closeDialog="closeAddCoordinatorsDialog"
      @submit="addCoordinators"
    />
  </div>
</template>

<script>
import buildShortNameFilter from "../../filters/buildShortNameFilter";
import DialogAddPeople from "./dialog-add-peopleV2";
import h from "../../services/h";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import tkTaskAssignService from "../../services/tkTaskAssignService";
import utils from "../../services/utils";
import errorMessageFilter from "../../filters/errorMessageFilter";

export default {
  name: "task-coodinators",
  components: { DialogAddPeople },
  filters: { buildShortNameFilter },
  props: ["delegatorId", "tkTaskId", "isAbleToUpdate", "receiverUserDeptRole"],
  data() {
    return {
      coordinators: [],
      isOpenAddCoordinatorsDialog: false,
      isEnableAddCoordinatorsDialog: false,
    };
  },

  computed: {
    coordinatorIds() {
      return h.collect(this.coordinators, (item) => item.id);
    },
  },

  watch: {
    isOpenAddCoordinatorsDialog(newValue) {
      newValue && (this.isEnableAddCoordinatorsDialog = newValue);
    },

    tkTaskId() {
      this.reloadData();
    },
  },

  created() {
    this.reloadData();
  },

  methods: {
    setCoordinators(coordinators) {
      this.coordinators = coordinators;
    },

    async reloadData() {
      if (this.tkTaskId) await this.loadCoordinators();
    },

    loadCoordinators() {
      return userDeptRoleViewService
        .findAllTaskCooperators(this.tkTaskId)
        .then((response) => (this.coordinators = response.data));
    },

    getData() {
      return h.collect(this.coordinatorIds, (item) => {
        return { coordinatorUserDeptRoleId: item };
      });
    },

    removeCoordinator(coordinator) {
      !this.tkTaskId
        ? this.coordinators.splice(this.coordinators.indexOf(coordinator), 1)
        : this.removeCoordinatorForUpdate(coordinator);
    },

    removeCoordinatorForUpdate(coordinator) {
      return utils
        .confirm(
          this.$confirm,
          errorMessageFilter({
            errorCode: "tkTask.taskAssign.removeConfirmMsg",
            params: [coordinator.fullName],
          })
        )
        .then(() =>
          tkTaskAssignService
            .findCoordinator(this.tkTaskId, coordinator.id)
            .then((response) => response.data)
        )
        .then((tkTaskAssign) => {
          return tkTaskAssignService
            .delete(tkTaskAssign.id)
            .then(() => {
              this.$message.success(
                errorMessageFilter({
                  errorCode: "tkTask.taskAssign.removeSuccess",
                })
              );
              this.coordinators.splice(
                this.coordinators.indexOf(coordinator),
                1
              );
            })
            .catch((error) => {
              this.commonHandleRequestError(error);
              throw error;
            });
        });
    },

    customLabelSelectPeople(userDeptRoleView) {
      return `${userDeptRoleView.fullName} (${userDeptRoleView.positionName} - ${userDeptRoleView.deptName})`;
    },

    closeAddCoordinatorsDialog() {
      this.isOpenAddCoordinatorsDialog = false;
    },

    addCoordinators(event) {
      h.each(event.userDeptRoleViews, (userDeptRoleView) => {
        if (
          h.exists(
            this.coordinators,
            (coordinator) => coordinator.id === userDeptRoleView.data.id
          )
        )
          return;
        this.coordinators.push(userDeptRoleView.data);
      });
      this.isOpenAddCoordinatorsDialog = false;
      if (this.tkTaskId) this.addCoordinatorsForUpdate();
    },

    addCoordinatorsForUpdate() {
      return tkTaskAssignService
        .addTaskAssigns({
          taskId: this.tkTaskId,
          coordinatorForms: this.getData(),
        })
        .then(() => this.loadCoordinators())
        .catch((error) => this.commonHandleRequestError(error));
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/job/task-coodinators.vue